import React, { Component } from 'react';

class WrongBtn extends Component {
    state = {
        wrongClass: false
    };

    handleTest = (event) => {
        console.log('ㄴ이ㅏ허ㅣ망ㄴ러히녀ㅘㅇㅎㅑㅓㅁㄷ기ㅐㅑ허ㅐㅑㅁㄷ거햐ㅐㅁㄷ겋');
        console.log(event);
        const wrongClass = this.state.wrongClass;
        this.setState({wrongClass: !wrongClass});
    };
    render() {
        return (
            <button type="button" className={this.state.wrongClass === true ? "btn wrong-btn active" : "btn wrong-btn"} onClick={this.handleTest}>오답</button>
        );
    }
}

export default WrongBtn;